/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExpertDocumentUrlDataDto = {
    /**
     * Expert document ID
     */
    id: string;
    /**
     * Expert ID who owns the document
     */
    expertId: string;
    /**
     * Type of expert document
     */
    documentType: ExpertDocumentUrlDataDto.documentType;
    /**
     * Verification status of the document
     */
    status: Record<string, any> | null;
    /**
     * MIME type of the stored document
     */
    mimeType: Record<string, any> | null;
    /**
     * Signed download URL for the expert document
     */
    url: string;
};
export namespace ExpertDocumentUrlDataDto {
    /**
     * Type of expert document
     */
    export enum documentType {
        CPR_CERTIFICATION = 'cpr_certification',
        FIRST_AID_CERTIFICATION = 'first_aid_certification',
        PT_CERTIFICATION = 'pt_certification',
        HIGHEST_EDUCATION = 'highest_education',
        BACHELORS_DEGREE = 'bachelors_degree',
        MASTERS_DEGREE = 'masters_degree',
        INTERNSHIP_CERTIFICATE = 'internship_certificate',
        PROFESSIONAL_LICENSE = 'professional_license',
        WORK_EXPERIENCE_PROOF = 'work_experience_proof',
        MA_MSC_PSYCHOLOGY = 'ma_msc_psychology',
        MPHIL_PSYD = 'mphil_psyd',
        CHILD_CERTIFICATION = 'child_certification',
        ACTIVE_LISTENING_TRAINING = 'active_listening_training',
        ADDITIONAL_CERTIFICATION = 'additional_certification',
        OTHER = 'other',
        PASSPORT = 'passport',
        EMIRATES_ID = 'emirates_id',
        AADHAR_CARD = 'aadhar_card',
    }
}

